// @ts-nocheck
// import React from 'react';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';

import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { addPayroll, getPayrolls } from '@store/HR/Payroll/PayrollSlice';
import { FormAddPayrollSchema } from '../../../ValidationForm/validationSchema';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import useGetPaymentMethod from '@hooks/Payrolls/use-Get-PaymentMethod';
import useGetAccounts from '@hooks/Finance/ChartAccountsDetails/useGetAccounts';
// import useGetGlLedgersList from '@hooks/Finance/useGetGlLedgersList';

export const AddPayroll = () => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const { PaymentMethodList } = useGetPaymentMethod();
  const { OptionsAccounts } = useGetAccounts();

  const formik = useFormik({
    initialValues: {
      name: '',
      name2: '',
      startDate: '',
      endDate: '',
      paymentMethodId: '',
      businessGroupId: null, ///////// ???
      numberOfYears: '',
      periodType: '',
      cutOffDate: '',
      accountId: ''
    },
    validationSchema: FormAddPayrollSchema(t),
    onSubmit: values => {
      dispatch(
        addPayroll({
          name: values.name,
          name2: values.name2,
          startDate: values.startDate,
          endDate: values.endDate,
          paymentMethodId: values.paymentMethodId,
          businessGroupId: values.businessGroupId,
          numberOfYears: values.numberOfYears,
          periodType: values.periodType,
          cutOffDate: values.cutOffDate,
          accountId: values.accountId
        })
      )
        .unwrap()
        .then(() => {
          formik.resetForm();
          document.getElementById('closeModalButton').click();
          CustomAlert({ action: 'Add' });
          dispatch(getPayrolls());
        })
        .catch(error => {
          CustomAlert({ action: 'Error' });
        })
        .finally(() => formik.setSubmitting(false));
    }
  });

  console.log(formik.errors);

  return (
    <Form onSubmit={formik.handleSubmit}>
      <div className='mb-4'>
        <h6 className=''>
          <i className='fas fa-lg fa-fw me-2 fa fa-info-circle text-theme'></i>
          المعلومات الأساسية
        </h6>
        <hr />
        <div>
          <div className='row'>
            <div className='col-xl-4'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('LocalName')}</label>
                <Form.Control
                  className='form-control'
                  type='text'
                  autoComplete='off'
                  name='name2'
                  onChange={formik.handleChange}
                  value={formik.values.name2}
                  isInvalid={!!formik.errors.name2}
                />
                <Form.Control.Feedback type='invalid'>
                  {/* {formik.errors.NATIONAL_IDENTIFIER} */}
                </Form.Control.Feedback>
              </div>
            </div>
            <div className='col-xl-4'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('GlobalName')}</label>
                <Form.Control
                  className='form-control'
                  type='text'
                  autoComplete='off'
                  name='name'
                  onChange={formik.handleChange}
                  value={formik.values.name}
                  isInvalid={!!formik.errors.name}
                />
                <Form.Control.Feedback type='invalid'>
                  {/* {formik.errors.NATIONAL_IDENTIFIER} */}
                </Form.Control.Feedback>
              </div>
            </div>
            <div className='col-xl-4'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('TypeOfDuration')}</label>
                <Form.Select
                  className='form-select'
                  name='periodType'
                  onChange={formik.handleChange}
                  value={formik.values.periodType}
                  isInvalid={!!formik.errors.periodType}
                >
                  <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                  <option value={'M'}> {i18n.language === 'ar' ? 'شهري' : 'Monthly'} </option>
                  <option value={'W'}> {i18n.language === 'ar' ? 'أسبوعي' : 'Weekly'} </option>
                </Form.Select>

                <Form.Control.Feedback type='invalid'>{/* {formik.errors.TITLE} */}</Form.Control.Feedback>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='mb-4'>
        <h6 className=''>
          <i className='fas fa-lg fa-fw me-2 fa-calendar-alt text-theme'></i>
          الفترة الزمنيـة
        </h6>
        <hr />
        <div>
          <div className='row'>
            <div className='col-xl-3'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Start Date')}</label>
                <Form.Control
                  type='date'
                  className='form-control'
                  name='startDate'
                  onChange={formik.handleChange}
                  value={formik.values.startDate}
                  isInvalid={!!formik.errors.startDate}
                />

                <div>
                  <Form.Control.Feedback type='invalid'>{/* {formik.errors.START_DATE} */}</Form.Control.Feedback>
                </div>
              </div>
            </div>

            <div className='col-xl-3'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('End_Date')}</label>
                <Form.Control
                  type='date'
                  className='form-control'
                  name='endDate'
                  onChange={formik.handleChange}
                  value={formik.values.endDate}
                  isInvalid={!!formik.errors.endDate}
                />

                <div>
                  <Form.Control.Feedback type='invalid'>{/* {formik.errors.START_DATE} */}</Form.Control.Feedback>
                </div>
              </div>
            </div>

            <div className='col-xl-3'>
              <div className='form-group mb-3'>
                <label className='form-label'>{i18n.language === 'en' ? 'Cut Off Date' : 'بداية حسـاب الراتب'}</label>

                <Form.Control
                  type='date'
                  className='form-control'
                  name='cutOffDate'
                  onChange={formik.handleChange}
                  value={formik.values.cutOffDate}
                  isInvalid={!!formik.errors.cutOffDate}
                />
              </div>
            </div>
            <div className='col-xl-3'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('NumberOfyears')}</label>
                <Form.Control
                  className='form-control'
                  type='number'
                  name='numberOfYears'
                  onChange={formik.handleChange}
                  value={formik.values.numberOfYears}
                  isInvalid={!!formik.errors.numberOfYears}
                />
                <Form.Control.Feedback type='invalid'>
                  {/* {formik.errors.NATIONAL_IDENTIFIER} */}
                </Form.Control.Feedback>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='mb-4'>
        <h6 className=''>
          <i className='fas fa-lg fa-fw me-2 fa-file-invoice-dollar text-theme'></i>
          المعلومات المـاليـة
        </h6>
        <hr />
        <div>
          <div className='row'>
            <div className='col-xl-4'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('PaymentMethod')}</label>
                <Form.Select
                  className='form-select'
                  name='paymentMethodId'
                  onChange={formik.handleChange}
                  value={formik.values.paymentMethodId}
                  isInvalid={!!formik.errors.paymentMethodId}
                >
                  <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                  {PaymentMethodList?.map((item, idx) => (
                    <option key={++idx} value={item.id}>
                      {i18n.language === 'ar' ? item.name2 : item.name}
                    </option>
                  ))}
                </Form.Select>
              </div>
            </div>

            <div className='col-xl-4 '>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Accounts')}</label>
                <Select
                  classNamePrefix='react-select'
                  className=' w-100'
                  // isLoading={loading}
                  isSearchable={true}
                  isClearable
                  options={OptionsAccounts}
                  placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                  onChange={option => {
                    formik.setFieldValue('accountId', option === null ? null : option.value);
                  }}
                />
              </div>
            </div>
            {/* <div className="col-xl-4">
          <div className="form-group mb-3">
            <label className="form-label">{t('Department')}</label>
            <Form.Select className="form-select">
              <option key={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
              <option>كشف الرواتب الافتراضي للمزايا المتقدمة</option>
            </Form.Select>
          </div>
        </div> */}
          </div>
        </div>
      </div>

      <div className='d-flex gap-2'>
        <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg btn-theme w-100 rounded-1'>
          {formik.isSubmitting ? (
            <div className='spinner-border spinner-border-sm me-2'></div>
          ) : (
            <i className='fas fa-lg fa-fw me-2 fa-plus'></i>
          )}
          {t('Add')}
        </button>

        <button
          type='button'
          className='btn btn-lg btn-default w-100 rounded-1'
          data-bs-dismiss='modal'
          id='closeModalButton'
        >
          <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
        </button>
      </div>
    </Form>
  );
};
